import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=a666cdbc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a666cdbc')) {
      api.createRecord('a666cdbc', component.options)
    } else {
      api.reload('a666cdbc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=a666cdbc&", function () {
      api.rerender('a666cdbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/videoIframe.vue"
export default component.exports